import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useAppStatus, AppStatus } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<AppStatus>
      useData={useAppStatus}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
